'use strict';

module.exports = function(colorA, colorB) {
	var i;
	var colorDiff = [];

	for (i = 0; i < 3; i++) {
		colorDiff.push(colorB[i] - colorA[i])
	}

	return colorDiff;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/granim/lib/colorDiff.js
// module id = H8O0
// module chunks = 0 1 2 6